// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgMicOff16 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 16 16"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.99991 4.70711L2.7928 1.5L2.08569 2.20711L5.99991 6.12132V7.5C5.99991 8.60457 6.89534 9.5 7.99991 9.5C8.39313 9.5 8.75985 9.38652 9.0691 9.19052L10.1715 10.2929C9.5756 10.7353 8.82173 11 7.99991 11C6.06071 11 4.49991 9.52602 4.49991 7.72253V5.27747H3.49991V7.72253C3.49991 9.93006 5.25474 11.7377 7.49991 11.9739V15H8.49991V11.9739C9.40099 11.8791 10.2231 11.5312 10.8845 11.0059L13.0857 13.2071L13.7928 12.5L11.5923 10.2995L10.879 9.58615L9.75414 8.46134L5.99991 4.70711ZM11.3574 8.65039L12.1305 9.42344C12.3681 8.90259 12.4999 8.32758 12.4999 7.72253V5.27747H11.4999V7.72253C11.4999 8.04449 11.4502 8.35595 11.3574 8.65039ZM6.00953 3.30252L9.99991 7.29289V3.5C9.99991 2.39543 9.10448 1.5 7.99991 1.5C6.96198 1.5 6.10871 2.29065 6.00953 3.30252Z"
				/>
			</Svg>
		);
	}
);
SvgMicOff16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgMicOff16;
